<template>
  <div>
    <span class="contents-map-loader"></span>
  </div>
</template>